export default __webpack_public_path__ + "static/media/logo_cargill_sider2.989c2ac6.jpg";